import { render, staticRenderFns } from "./FormVenta.vue?vue&type=template&id=6b9ffb80&scoped=true&"
import script from "./FormVenta.vue?vue&type=script&lang=js&"
export * from "./FormVenta.vue?vue&type=script&lang=js&"
import style0 from "./FormVenta.vue?vue&type=style&index=0&id=6b9ffb80&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b9ffb80",
  null
  
)

export default component.exports